import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';

import { F8865SchdKComponent } from './components/f8865-schd-k/f8865-schd-k.component';
import { F8865SchdKService } from './services/f8865-schd-k.service';

@NgModule({
  declarations: [
    F8865SchdKComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule
  ],
  exports: [
    F8865SchdKComponent
  ],
  providers: [
    F8865SchdKService
  ]
})
export class FirForm8865Module { } 
